import { render, staticRenderFns } from "./d-post-poll.vue?vue&type=template&id=3c52117a&scoped=true&"
import script from "./d-post-poll.vue?vue&type=script&lang=js&"
export * from "./d-post-poll.vue?vue&type=script&lang=js&"
import style0 from "./d-post-poll.vue?vue&type=style&index=0&id=3c52117a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c52117a",
  null
  
)

export default component.exports